import { render, staticRenderFns } from "./systemTransPriceRecordformation.vue?vue&type=template&id=7238a709&scoped=true&"
import script from "./systemTransPriceRecordformation.vue?vue&type=script&lang=js&"
export * from "./systemTransPriceRecordformation.vue?vue&type=script&lang=js&"
import style0 from "./systemTransPriceRecordformation.vue?vue&type=style&index=0&id=7238a709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238a709",
  null
  
)

export default component.exports